
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ObjectManager } from '../../../concepts/objects';
import { ActiveObject, resolve } from '../../Container';
import { Sticky } from '../paper/Sticky';
import { TaskRecordAttr } from './TaskAssocations';
import { taskSetSummary } from './TaskCommands';

export class TaskMechanics extends ActiveObject {

    @resolve(CommandDispatcher) private dispatch!: CommandDispatcher;
    @resolve(ObjectManager) private objects!: ObjectManager;

    public start(): void {
        this.burden(
            this.objects.createInterceptor('Task.Content')
                .for(Sticky)
                .on('content', this.createInterceptorCallbacks()),
        );
    }

    private createInterceptorCallbacks() {
        return {
            get: (obj, value) => {
                const task = TaskRecordAttr.get(obj);
                if (task) {
                    return task.summary ?? value;
                }
                return value;
            },
            set: (obj, value) => {
                const task = TaskRecordAttr.get(obj);
                if (task) {
                    this.dispatch(taskSetSummary, [value, [obj.id]]);
                }
                return value;
            },
        };
    }
}
